{
  "APP_NAME": "punch olo",
  "About": "About",
  "Hello world !": "Hello world !",
  "Home": "Home",
  "Logged in as": "Logged in as",
  "Login": "Login",
  "Logout": "Logout",
  "Password": "Password",
  "Password is required": "Password is required",
  "Username": "Username",
  "Username is required": "Username is required",
  "Username or password incorrect.": "Username or password incorrect.",
  "Remember me": "Remember me",
  "Version": "Version"
}
